import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RangeGroupSelectorComponent } from './range-group-selector.component';
import { FormsModule,ReactiveFormsModule} from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [RangeGroupSelectorComponent],
  exports: [RangeGroupSelectorComponent]
})
export class RangeGroupSelectorComponentModule {

}